import { useSession } from "@features/session/hooks/useSession";
import type { PracticeTestExam } from "@memorang/types/src/tag";
import { router } from "expo-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
const useDiagnostic = () => {
	const { t } = useTranslation();

	const messages = [
		t("sessionConfig.configuringSession"),
		t("sessionConfig.fetchingContent"),
		t("sessionConfig.preparingMaterials"),
		t("sessionConfig.almostThere"),
		t("sessionConfig.startingSession"),
	];
	const [showPermissionDialog, setShowPermissionDialog] = useState(false);
	const { handleCreateCommonSession, isCreatingSession } = useSession();
	const handleCreateSession = ({
		isSessionConfig,
		handleClose,
		exam,
	}: {
		exam: PracticeTestExam;
		isSessionConfig?: boolean;
		handleClose?: () => void;
	}) => {
		const dist = {
			low: 0,
			high: 0,
			medium: 0,
			none: 0,
		};

		handleCreateCommonSession({
			dist,
			tags: [],
			handleClose,
			push: !isSessionConfig,
			additionalSessionParams: {
				title: exam?.title!,
				icon: exam?.icon!,
				sessionSubType: "DIAGNOSTIC",
				examId: exam?.id,
				collectionId: exam?.collectionId,
			},
		});
	};

	const handleViewReport = (sessionNumericId: number) => {
		router.replace({
			pathname: "/(protected)/session/[id]/report",
			params: {
				id: sessionNumericId,
			},
		});
	};

	return {
		handleCreateSession,
		handleViewReport,
		showPermissionDialog,
		isCreatingSession,
		setShowPermissionDialog,
		messages,
	};
};

export default useDiagnostic;
